<template>
  <div class="ppv-filter-group">
    <div class="ppv-filter-label">{{ $t("ppv.filters.date_range") }}</div>
    <div class="ppv-chips-row">
      <PpvChip
        v-for="d in dateRanges"
        :key="d.value"
        :selected="selectedRange === d.value"
        :icon="d.icon || ''"
        @click="onSelect(d.value)"
      >
        {{ $t(d.label) }}
      </PpvChip>
    </div>
  </div>
</template>

<script>
import PpvChip from '../shared/PpvChip.vue'

export default {
  name: 'PpvDateFilter',
  components: { PpvChip },
  props: {
    selectedRange: { type: String, required: true },
    dateRanges: { type: Array, required: true },
    onSelect: { type: Function, required: true },
  },
}
</script>

<style scoped>
.ppv-filter-group {
  margin-bottom: 20px;
}
.ppv-filter-label {
  font-size: 11px;
  font-weight: 700;
  color: #8a96a8;
  letter-spacing: 0.08em;
  margin-bottom: 12px;
  text-transform: uppercase;
}
.ppv-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
</style>
